export default __webpack_public_path__ + "static/media/Definix-Trading-Challenge-11.de464d4d.png";